<template>
  <div :class="{ topcontainer: view === 'table' }" ref="topcontainer">
    <share :resource="'document'" :id="id" :job_options="job_options" ref="share" :new_jobs.sync="vjobs" :new_user_ids.sync="vuser_ids" />
    <add_tag :resource="'document'" :id="id" :tags="tags" :tag_options="tag_options" :business_unit_id="business_unit_id" />
    <div class="row-item" :class="{ oddrow: odd }" v-if="view === 'table'" :data-id="id">
      <div class="documents_start_block">
        <div class="buttons flex-center">
          <i class="fa-light fa-trash red" v-if="(canDelete || canEdit) && !folder_closed && !enable_only_reports" @click="deleteDoc" />
        </div>
        <div class="type"><i :class="icon" class="icon fa-light fa-2x" /></div>
        <div :class="`title-and-tags ${kind || type}`">
          <div class="title" v-if="!editingTitle" @click="toggleTitleEdit">{{ visibleTitle }}</div>
          <div class="document_actions">
            <div class="preview_activator" v-if="show_preview">
              <a :href="url" target="_blank" :title="filename">
                <i class="fa-light fa-eye" />
              </a>
            </div>
            <div class="file-name">
              <div v-if="relative_to" class="relative_to_inline">{{ relative_to }}</div>
              <template v-if="only_preview">
                {{ filename }}
                <span v-if="fseTypes" class="js-tooltip badge badge-primary" title="Documento Fse"> FSE </span>

                <span class="size" v-if="size"> ({{ size }}) </span>
                <p class="row-info text-danger" v-if="prevPeriod">{{ prevPeriodMsg }}</p>
              </template>
              <template v-else>
                <a :href="url" target="_blank" :title="filename">
                  <i class="fa-light fa-cloud-arrow-down" />
                  {{ filename }}
                  <span v-if="fseTypes" class="js-tooltip badge badge-primary" title="Documento Fse"> FSE </span>

                  <span class="size" v-if="size"> ({{ size }}) </span>
                  <p class="row-info text-danger" v-if="prevPeriod">{{ prevPeriodMsg }}</p>
                </a>
              </template>
            </div>
          </div>
          <input
            class="title-input"
            ref="inputTitle"
            @blur="confirmTitle"
            @keyup.enter="confirmTitle"
            @keyup.esc="undoEdit"
            :v-model="new_title"
            :value="new_title"
            v-if="editingTitle"
          />
          <div v-if="new_tags && new_tags.length > 0" class="tag-list">
            <div
              v-for="tag in new_tags"
              v-bind:key="tag.id"
              class="tag badge badge-info"
              :style="computedStyle(tag)"
              @click="emitClickOnTag"
            >
              <i class="fa-light" :class="tag.faicon || 'fa-tag'" />
              {{ tag.cod }}
            </div>
          </div>
          <div v-else class="add-new-tag">
            <div v-if="canEdit && !folder_closed && !enable_only_reports">
              <a href="#" @click="emitClickOnTag">
                <i class="fa-light fa-circle-plus" />
                TAG
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="documents_end_block">
        <div class="flags_and_sign">
          <stepper
            v-if="pdf && stored_status"
            :step="stored_status"
            :title_prefix="'sign_states'"
            :steps="[
              { name: 'to_upload', i: 0, ico: 'file-signature' },
              { name: 'uploaded', i: 1, ico: 'cloud-upload' },
              { name: 'rdv_ok', i: 2, ico: 'inbox-in', error: 'rdv_nok' },
            ]"
          />
          <div class="flags">
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vpersonal, clickable: !vreserved || superOrCreator }"
              :title="personalMsg"
              :disabled="vreserved && !superOrCreator"
              @click="togglePersonal"
            >
              <i class="fa-light fa-user fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vpersonal"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vreserved, clickable: superOrCreator }"
              :title="privacyMsg"
              :disabled="!superOrCreator"
              @click="toggleReserved"
            >
              <i class="fa-light fa-user-secret fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vreserved"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vsan, clickable: (!vreserved || superOrCreator) && can.permit.includes('toggle_san') }"
              :title="sanMsg"
              :disabled="(vreserved && !superOrCreator) || !can.permit.includes('toggle_san')"
              @click="toggleSan"
            >
              <i class="fa-light fa-notes-medical fa-stack-1x" :class="{ red: vsan }"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vsan"></i>
            </span>
            <span
              v-if="(canEdit || canAttachPrintFolder) && pdf && gpds_id"
              class="fa-stack fa-light js-tooltip clickable"
              :class="{ disabled: !vpwf }"
              :title="pwfMsg"
              @click="togglePwf"
            >
              <i class="fa-light fa-paperclip fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vpwf"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !anyShare, clickable: superOrCreator }"
              :title="shareMsg"
              @click="toggleShare"
            >
              <i class="fa-light fa-share fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!anyShare"></i>
            </span>
            <span v-if="canSign && sign_enabled && canEdit" class="fa-stack fa-light js-tooltip" :title="signMsg" @click="signDocument">
              <i class="fa-light fa-file-signature fa-stack-1x"></i>
            </span>
          </div>
        </div>
        <div class="editor">
          <user-media :fullname="editor" :job="editor_job" :img="!isMobile && avatar" :datetime="updated_at" />
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="item" v-if="view === 'cards'" :data-id="id">
        <div class="row-info text-danger" v-if="prevPeriod">
          <span class="fa-light fa-triangle-exclamation js-tooltip" :title="prevPeriodMsg"></span>
        </div>
        <div :class="`header ${kind || type}`">
          <i :class="icon" class="icon fa-light fa-2x" />
          <div class="title" v-if="!editingTitle" @click="toggleTitleEdit">{{ visibleTitle }}</div>
          <input
            class="title-input"
            ref="inputTitle"
            @blur="confirmTitle"
            @keyup.enter="confirmTitle"
            @keyup.esc="undoEdit"
            :v-model="new_title"
            :value="new_title"
            v-if="editingTitle"
          />
        </div>
        <div v-if="relative_to" class="relative_to">{{ relative_to }}</div>
        <hr />
        <div v-if="new_tags && new_tags.length > 0" class="tag-list">
          <div v-for="tag in new_tags" v-bind:key="tag.id" class="tag badge badge-info" :style="computedStyle(tag)" @click="emitClickOnTag">
            <i class="fa-light" :class="tag.faicon || 'fa-tag'" />
            {{ tag.cod }}
          </div>
        </div>
        <div v-else class="add-new-tag">
          <div v-if="canEdit">
            <a href="#" @click="emitClickOnTag">
              <i class="fa-light fa-circle-plus" />
              TAG
            </a>
          </div>
        </div>
        <div class="document_actions">
          <div class="preview_activator" v-if="show_preview">
            <a :href="url" target="_blank" :title="filename">
              <i class="fa-light fa-eye" />
            </a>
          </div>
          <div class="file-name">
            <template v-if="only_preview">
              <a :href="url" target="_blank" :title="filename">
                {{ filename }}
              </a>
            </template>
            <template v-else>
              <i class="fa-light fa-cloud-arrow-down" />
              {{ filename }}
            </template>
          </div>
        </div>
        <span v-if="fseTypes" class="badge badge-primary js-tooltip" title="Documento Fse"> FSE </span>
        <span class="size" v-if="size">
          {{ size }}
        </span>
        <div class="flags-row">
          <div class="flags">
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vpersonal, clickable: !vreserved || superOrCreator }"
              :title="personalMsg"
              :disabled="vreserved && !superOrCreator"
              @click="togglePersonal"
            >
              <i class="fa-light fa-user fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vpersonal"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vreserved, clickable: superOrCreator }"
              :title="privacyMsg"
              :disabled="!superOrCreator"
              @click="toggleReserved"
            >
              <i class="fa-light fa-user-secret fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vreserved"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !vsan, clickable: (!vreserved || superOrCreator) && can.permit.includes('toggle_san') }"
              :title="sanMsg"
              :disabled="(vreserved && !superOrCreator) || !can.permit.includes('toggle_san')"
              @click="toggleSan"
            >
              <i class="fa-light fa-notes-medical fa-stack-1x" :class="{ red: vsan }"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vsan"></i>
            </span>
            <span
              v-if="(canEdit || canAttachPrintFolder) && pdf && gpds_id"
              class="fa-stack fa-light js-tooltip clickable"
              :class="{ disabled: !vpwf }"
              :title="pwfMsg"
              @click="togglePwf"
            >
              <i class="fa-light fa-paperclip fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!vpwf"></i>
            </span>
            <span
              v-if="canEdit"
              class="fa-stack fa-light js-tooltip"
              :class="{ disabled: !anyShare, clickable: superOrCreator }"
              :title="shareMsg"
              @click="toggleShare"
            >
              <i class="fa-light fa-share fa-stack-1x"></i>
              <i class="fa-light fa-ban fa-stack-2x" v-if="!anyShare"></i>
            </span>
            <span v-if="canSign && sign_enabled && canEdit" class="fa-stack fa-light js-tooltip" :title="signMsg" @click="signDocument">
              <i class="fa-light fa-file-signature fa-stack-1x"></i>
            </span>
          </div>
        </div>

        <div class="item_end_block">
          <stepper
            v-if="pdf && stored_status"
            :step="stored_status"
            :title_prefix="'sign_states'"
            :steps="[
              { name: 'to_upload', i: 0, ico: 'file-signature' },
              { name: 'uploaded', i: 1, ico: 'cloud-upload' },
              { name: 'rdv_ok', i: 2, ico: 'inbox-in', error: 'rdv_nok' },
            ]"
          />

          <div class="editor">
            <user-media :fullname="editor" :job="editor_job" :img="!isMobile && avatar" :datetime="updated_at" />
          </div>
          <div class="delete-row fa-light fa-trash" v-if="canDelete" @click="deleteDoc" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import add_tag from '../tags/add_tag';
import axios from 'axios';
import { Route } from '../../route';
import share from '../share/share';
import stepper from '../stepper';

import userMedia from '../userMedia';

export default {
  name: 'documentz',
  props: [
    'view_type',
    'id',
    'permissions',
    'current_gpds_id',
    'gpds_id',
    'business_unit_id',
    'stored_status',
    'editor',
    'editor_job',
    'kind',
    'avatar',
    'size',
    'signed',
    'sign_enabled',
    'shared_jobs',
    'shared_ubu_ids',
    'pwf',
    'odd',
    'relative_to',
    'filename',
    'tags',
    'tag_options',
    'job_options',
    'title',
    'content_type',
    'reserved',
    'san',
    'url',
    'updated_at',
    'created_who',
    'view',
    'personal',
    'last_period',
    'infos',
    'show_preview',
    'only_preview',
    'folder_closed',
    'enable_only_reports',
  ],
  data() {
    return {
      vreserved: false,
      vsan: false,
      vpwf: false,
      vpersonal: false,
      vjobs: [],
      vuser_ids: [],
      vsigned: false,
      new_title: null,
      can: { permit: [] },
      prevTitleValue: null,
      editingTitle: false,
      loading: true,
      new_tags: [],
      windowWidth: window.innerWidth,
    };
  },
  components: {
    add_tag,
    share,
    stepper,
    userMedia,
  },
  computed: {
    canSign() {
      return !this.fseTypes;
    },
    fseTypes() {
      return this.kind == 'fse_ldo' || this.kind == 'fse_rsa';
    },
    prevPeriod() {
      if (this.view_type === 'business_unit' || this.view_type === 'users_business_unit') {
        return false;
      }

      return (this.gpds_id && this.current_gpds_id !== 0 && this.gpds_id !== this.current_gpds_id) || !this.last_period;
    },
    canDelete() {
      return this.can.permit.includes('destroy');
    },
    canEdit() {
      return this.can.permit.includes('edit');
    },
    canAttachPrintFolder() {
      return this.can.permit.includes('attach_to_print_folder');
    },
    anyShare() {
      return (this.vuser_ids && this.vuser_ids.length) || (this.vjobs && this.vjobs.length);
    },
    tagIds() {
      return this.new_tags.map((tag) => {
        return tag.id;
      });
    },
    pdf() {
      return this.content_type === 'application/pdf';
    },
    type() {
      return window.location.pathname.split('/').pop();
    },
    icon() {
      switch (this.content_type) {
        case 'application/pdf':
          return 'fa-file-pdf red';
        case 'image/jpeg':
        case 'image/png':
        case 'image/tiff':
        case 'image/bmp':
        case 'image/heic':
        case 'image/svg+xml':
        case 'image/gif':
        case 'image/webp':
          return 'fa-file-image';
        case 'application/msword':
          return 'fa-file-word msword';
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/vnd.oasis.opendocument.text':
          return 'fa-file-word oodoc';
        case 'application/vnd.ms-excel':
        case 'application/excel':
          return 'fa-file-excel msexcel';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.oasis.opendocument.spreadsheet':
          return 'fa-file-excel oocalc';
        case 'text/plain':
        case 'application/rtf':
          return 'fa-file-lines';
        case 'application/zip':
        case 'application/x-rar-compressed':
        case 'application/x-7z-compressed':
        case 'application/x-zip-compressed':
          return 'fa-file-zipper';
        case 'video/x-msvideo':
        case 'video/3gpp':
        case 'video/quicktime':
        case 'application/mp4':
          return 'fa-file-video';
        case 'text/csv':
        case 'text/comma-separated-values':
          return 'fa-file-csv';
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.ms-powerpoint':
        case 'application/powerpoint':
        case 'application/x-iwork-keynote-sffkey':
        case 'application/vnd.oasis.opendocument.presentation':
          return 'fa-presentation-screen';
        case 'application/vnd.ms-outlook':
        case 'message/rfc822':
          return 'fa-at';
        case 'application/dicom':
          return 'fa-x-ray';
        case 'text/html':
          return 'fa-file-code';
        case 'audio/mp4':
        case 'audio/mpeg':
          return 'fa-music';
        default:
          return 'fa-file';
      }
    },
    prevPeriodMsg() {
      return i18nJS.doc_index_flags.pre_period;
    },
    personalMsg() {
      return this.personal ? i18nJS.doc_index_flags.personal : i18nJS.doc_index_flags.not_personal;
    },
    signMsg() {
      return this.vsigned ? i18nJS.doc_index_flags.sig : i18nJS.doc_index_flags.not_sig;
    },
    privacyMsg() {
      return this.vreserved ? i18nJS.doc_index_flags.res : i18nJS.doc_index_flags.not_res;
    },
    sanMsg() {
      return this.vsan ? i18nJS.doc_index_flags.san : i18nJS.doc_index_flags.not_san;
    },
    pwfMsg() {
      return this.vpwf ? i18nJS.doc_index_flags.pwf : i18nJS.doc_index_flags.not_pwf;
    },
    shareMsg() {
      return i18nJS.doc_index_flags.manage_shares;
    },
    superOrCreator() {
      return window.config.user.super || window.config.user.id === this.created_who;
    },
    visibleTitle() {
      return this.new_title || '--';
    },
  },
  mounted() {
    this.can = this.permissions;
    this.new_title = this.title;
    this.new_tags = this.tags;
    this.vreserved = this.reserved;
    if (this.shared_jobs) {
      this.$set(this, 'vjobs', this.shared_jobs);
      this.$set(this.$refs.share, 'new_jobs', this.shared_jobs);
    }
    if (this.shared_ubu_ids) {
      const user_ids = Object.keys(this.shared_ubu_ids).map(Number);
      this.$set(this, 'vuser_ids', user_ids);
      this.$set(this.$refs.share, 'new_user_ids', user_ids);
      eventBus.$emit('initUserSelect', { id: this.id, resource: 'document', selected: this.shared_ubu_ids });
    }
    this.vsigned = this.signed;
    this.vpersonal = this.personal;
    this.vsan = this.san;
    this.vpwf = this.pwf;
    this.prevTitleValue = this.new_title;
    eventBus.$on('tagUpdated', this.handleTagsUpdate);
    eventBus.$on('shareUpdates', this.handleShareUpdates);
  },
  methods: {
    async update(config) {
      const { url, method } = config;
      return axios({
        method,
        url,
        data: { id: this.id },
        headers: {
          'Content-type': 'application/json',
          'X-CSRF-Token': $.rails.csrfToken(),
        },
      });
    },
    error(err) {
      let msg = `${i18nJS.errors.critical_error}: ${err.message}`;
      if (err.response.status === 401) {
        msg = i18nJS.access_denied;
      }
      Utils.appendToFlash('error', msg);
    },
    async togglePersonal() {
      if ((!this.vreserved || this.superOrCreator) && this.canEdit) {
        eventBus.$emit('updatingDoc', { id: this.id });
        try {
          const res = await this.update({
            url: `${Route.DOCUMENT_TOGGLE_PERSONAL}.json`,
            method: 'put',
          });
          this.vpersonal = res.data.personal;
        } catch (err) {
          this.error(err);
        }
        eventBus.$emit('updatedDoc', { id: this.id, success: true });
      }
    },
    async toggleReserved() {
      if (this.superOrCreator && this.canEdit) {
        eventBus.$emit('updatingDoc', { id: this.id });
        try {
          const res = await this.update({
            url: `${Route.DOCUMENT_TOGGLE_RESERVED}.json`,
            method: 'put',
          });
          this.vreserved = res.data.riservato;
          this.vpwf = res.data.pwf;
        } catch (err) {
          this.error(err);
        }
        eventBus.$emit('updatedDoc', { id: this.id, success: true });
      }
    },
    handleTagsUpdate(data) {
      if (data.id === this.id && data.resource === 'document' && data.tags) {
        this.new_tags.splice(0, this.new_tags.length);
        data.tags.forEach((tag) => this.new_tags.push(tag));
      }
    },
    handleShareUpdates(data) {
      if (data.id === this.id && data.resource === 'document') {
        axios({
          method: 'put',
          url: `${Route.DOCUMENT}/${this.id}.json`,
          data: { shared_ubu_ids: data.user_ids || [-1], shared_jobs: data.jobs || [-1] },
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((res) => {
            this.$set(this, 'vjobs', data.jobs);
            this.$set(this, 'vuser_ids', data.user_ids);
          })
          .catch((err) => this.error(err));
      }
    },
    async toggleSan() {
      if ((!this.vreserved || this.superOrCreator) && this.canEdit && this.can.permit.includes('toggle_san')) {
        eventBus.$emit('updatingDoc', { id: this.id });
        try {
          const res = await this.update({
            url: `${Route.DOCUMENT_TOGGLE_SAN}.json`,
            method: 'put',
          });
          this.vsan = res.data.san;
          eventBus.$emit('updatedDoc', { id: this.id, success: true });
        } catch (err) {
          this.error(err);
        }
      }
    },
    async togglePwf() {
      if (this.canEdit) {
        eventBus.$emit('updatingDoc', { id: this.id });
        try {
          const res = await this.update({
            url: `${Route.DOCUMENT_TOGGLE_PWF}.json`,
            method: 'put',
          });
          this.vpwf = res.data.pwf;
          this.vreserved = res.data.riservato;
        } catch (err) {
          this.error(err);
        }
        eventBus.$emit('updatedDoc', { id: this.id, success: true });
      }
    },
    confirmTitle() {
      if (this.canEdit) {
        eventBus.$emit('updatingDoc', { id: this.id });
        axios({
          method: 'put',
          url: `${Route.DOCUMENT}/${this.id}.json`,
          data: { document: { description: this.$refs.inputTitle.value } },
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((res) => {
            eventBus.$emit('updatedDoc', { id: this.id, success: true });
            this.editingTitle = false;
            this.new_title = this.$refs.inputTitle.value;
            this.prevTitleValue = this.$refs.inputTitle.value;
          })
          .catch((err) => this.error(err));
      }
    },
    computedStyle(tag) {
      if (tag.fillcolor) {
        return `background-color: ${tag.fillcolor};`;
      }
    },
    emitClickOnTag() {
      if (this.canEdit) {
        eventBus.$emit('editTag', { id: this.id, resource: 'document' });
      }
    },
    deleteDoc() {
      if (this.canDelete && confirm(i18nJS.javascript.alert.confirmation)) {
        eventBus.$emit('updatingDoc', { id: this.id });
        axios({
          method: 'delete',
          url: `${Route.DOCUMENT}/${this.id}.json`,
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((res) => {
            this.$refs.topcontainer.classList.add('removed-item');
            eventBus.$emit('tags_count_changes', { remove: this.tagIds });
            setTimeout(() => {
              eventBus.$emit('removedDoc', { id: this.id, success: true });
            }, 800);
          })
          .catch((err) => this.error(err));
      }
    },
    signDocument() {
      eventBus.$emit('sign-document', {
        documentUrl: this.url,
        dsdKind: 'cartella',
        infos: this.infos,
      });
    },
    toggleShare() {
      eventBus.$emit('editShare', { id: this.id, resource: 'document' });
    },
    toggleTitleEdit() {
      if (this.canEdit) {
        this.editingTitle = true;
        this.$nextTick(function () {
          if (this.$refs.inputTitle) {
            this.$refs.inputTitle.focus();
          }
        });
      }
    },
    undoEdit() {
      this.new_title = this.prevTitleValue;
      this.editingTitle = false;
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler(val) {
        this.isMobile = val <= 1000;
      },
    },
  },
};
</script>

<style lang="scss">
.topcontainer .stepper {
  justify-content: flex-start;
  display: none;
  width: auto;

  @media screen and (min-width: 1024px) {
    display: flex;
  }
}
</style>

<style lang="scss" scoped>
div.removed-item {
  animation: removed-item-animation 0.6s cubic-bezier(0.55, -0.04, 0.91, 0.94) forwards;
}

@keyframes removed-item-animation {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0);
  }
}

.buttons {
  width: 3%;
  & > i {
    cursor: pointer;
    padding: 1em;
  }
}
.topcontainer {
  width: 100%;

  .editor {
    width: 30%;
  }
}
.item {
  position: relative;
  width: 200px;
  padding: 1em 1.5em;
  margin: 20px;
  color: #333;
  background: #e9e9e9;
  overflow: hidden;
  & > hr {
    margin-bottom: 10px;
  }
  height: 400px;

  .item_end_block {
    position: absolute;
    bottom: 10px;
  }

  .editor {
    margin-top: 20px;
  }
}

.delete-row {
  cursor: pointer;
  background-color: #c11;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  padding: 5px;
  color: #fff;
  margin: 1em auto 0;
}

.document_actions {
  display: flex;
  align-items: baseline;

  .preview_activator {
    margin-right: 6px;
  }
}

.row-item {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  position: relative;
  align-items: center;
  padding-bottom: 10px;
  justify-content: space-between;

  .documents_start_block {
    display: flex;
    width: 40%;
  }

  .documents_end_block {
    display: flex;
    width: 60%;
    justify-content: flex-end;
  }

  .flags_and_sign {
    display: flex;
    justify-content: flex-end;
    width: 70%;

    .flags {
      display: flex;
      align-items: center;
      width: 200px;
      justify-content: flex-end;

      > span {
        margin: 0 4px;
      }
    }
  }
}

.title-and-tags > .title-input,
.title {
  width: 100%;
  margin: 5px 0px 0px;
  margin-bottom: 0px !important;
}

.file-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
}

.item:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 16px 16px 0;
  border-style: solid;
  border-color: #fff #fff #a3a59e #a3a59e;
  background: #a3a59e;
  box-shadow:
    0 1px 1px rgba(0, 0, 0, 0.3),
    -1px 1px 1px rgba(0, 0, 0, 0.2);
  /* Firefox 3.0 damage limitation */
  display: block;
  width: 0;
}

.fa-stack {
  width: 1.6em;
}
.item.rounded {
  -moz-border-radius: 5px 0 5px 5px;
  border-radius: 5px 0 5px 5px;
}

.item.rounded:before {
  border-width: 8px;
  border-color: #fff #fff transparent transparent;
  -moz-border-radius: 0 0 0 5px;
  border-radius: 0 0 0 5px;
}
.header {
  position: relative;
  white-space: nowrap;
}
.header:before,
.title-and-tags:after {
  position: absolute;
  font-family: 'Font Awesome 6 Pro';
  font-size: 20px;
  opacity: 0.5;
}

.header:before {
  top: 12px;
  right: 10px;
}
.title-and-tags:after {
  left: -26px;
  top: 14px;
}
.title-and-tags.cartella:after {
  content: '\f7e6';
}
.header.cartella:before {
  content: '\f7e6';
}
.title-and-tags.ldd:after {
  content: '\f8e7';
}
.header.ldd:before {
  content: '\f8e7';
}
.title-and-tags.rso:after {
  content: '\f61d';
}
.header.rso:before {
  content: '\f61d';
}
.title-and-tags.terapia:after {
  content: '\f484';
}
.header.terapia:before {
  content: '\f484';
}
.title-and-tags.business_unit:after {
  content: '\f80a';
}
.header.business_unit:before {
  content: '\f80a';
}
.title-and-tags.guest:after {
  content: '\f007';
}
.header.guest:before {
  content: '\f007';
}
.title-and-tags.users_business_unit:after {
  content: '\f6a4';
}
.header.users_business_unit:before {
  content: '\f6a4';
}
.relative_to {
  margin-top: 1em;
  text-align: right;
  color: #038489;
}
.relative_to_inline {
  line-height: 1.2em;
  color: #038489;
}
hr {
  margin-top: 0.5em;
}
.title {
  display: inline-flex;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon {
  margin-right: 10px;
}
.size {
  margin: auto 0;
  font-size: 12px;
}
.tag-list {
  list-style: none;
  display: block;
  margin: 0 5px 10px 0;
  white-space: normal;
  width: 200px;
  .tag {
    display: inline-block;
    cursor: pointer;
  }
}
.flags-row {
  display: flex;
  justify-content: space-between;
}
.flags > .clickable {
  cursor: pointer;
}

.add-new-tag {
  border-radius: 4px;
  padding: 0 5px;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #3a87ad;
  width: 100%;
  text-align: center;
  & > a {
    color: #3a87ad;
  }
}
.disabled {
  color: #ccc;
}
.type {
  margin: 0.2em 1em;
}
.title-and-tags {
  width: 70%;
  margin-left: 10px;
  display: flex;
  flex-flow: column;
  position: relative;
  white-space: nowrap;
  & > .title {
    line-height: 1.5em;
    width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  & > .add-new-tag {
    line-height: 1em;
    width: 90%;
    padding: 0.2em;
  }
}
.title-input {
  width: auto;
  line-height: 1em;
  padding: 5px;
}
.fa-ban {
  font-size: 1.7em;
  top: 3px;
}

.oddrow {
  background-color: #f9f9f9;
}

.editor {
  margin-left: 10px;
}

.fa-file-signature {
  color: var(--adv-primary-color);
}

.fa-file-signature::before {
  font-size: 16px;
}

.badge-primary {
  background-color: var(--adv-primary-color);
}
</style>
